import {Component, OnInit} from '@angular/core';
import {UserNotificationService} from '@webmate-web-core/shared/services/usernotification.service';
import {map, mergeMap} from 'rxjs/operators';
import {faCommentLines} from '@fortawesome/pro-light-svg-icons';
import {ManageProjectsPermission} from '@webmate-web-core/shared/constants/permission.constants';
import {UserService} from '@webmate-web-core/shared/services/user.service';
import moment from 'moment';
import {ModalToolContainerService} from '../../tools/modaltoolcontainer/modaltoolcontainer.service';
import {DateTime} from '@webmate-web-core/shared/types/base-types';
import {CustomerScope} from '@webmate-web-core/shared/types/ids';
import {CustomerService} from '@webmate-web-core/shared/services/customer.service';
import {ChannelInfo, OrgAdminTopics, UserNotification} from '@webmate-web-core/shared/types/notification';
import {
    NotificationData,
    NotificationEditorToolComponent,
    NotificationEditorToolConfig
} from '@webmate-web-core/shared/tools/notification-editor/notification-editor-tool.component';

@Component({
    templateUrl: './usernotificationarea.component.html',
    styleUrls: ['./usernotificationarea.component.less']
})
export class UserNotificationAreaComponent implements OnInit {

    seenDate: DateTime;
    lastDate: DateTime;
    notifications: Array<UserNotification>;

    isAdmin: boolean = false;
    faCommentLines = faCommentLines;
    moment = moment;

    constructor(private userNotificationService: UserNotificationService, private toolService: ModalToolContainerService,
                private userService: UserService, private customerService: CustomerService) {}

    ngOnDestroy() {
        // we mark notifications as seen as soon as the dialog is closed
        if ((!this.seenDate && !!this.lastDate) || (!!this.lastDate && moment(this.lastDate).isAfter(this.seenDate))) {
            this.userNotificationService.markChannelSeen$('notification-center', this.lastDate).subscribe();
        }
    }

    ngOnInit() {
        this.userNotificationService.observeNotificationCenterNotifications$().pipe(mergeMap(notifications => {
            return this.userNotificationService.getChannelInfo$('notification-center').pipe(map(channelInfo => [notifications, channelInfo] as [Array<UserNotification>, ChannelInfo]))
        })).subscribe(([notifications, channelInfo]: [Array<UserNotification>, ChannelInfo]) => {
            this.notifications = notifications;
            this.seenDate = channelInfo.lastSeen;
            this.lastDate = notifications[0]?.creationTime;
        });

        this.userService.hasAdminPermission(ManageProjectsPermission).subscribe(isAdmin => {
            this.isAdmin = isAdmin;
        })
    }

    openNotificationDialog(event: MouseEvent) {
        this.toolService.openTool(NotificationEditorToolComponent, new NotificationEditorToolConfig('New Admin Notification', this.sendNotification.bind(this), OrgAdminTopics ));
    }

    sendNotification(data: NotificationData): void {
        this.userNotificationService.addNotification$({type: 'CustomerScope'} as CustomerScope, data.topic, data.title, data.text).subscribe(() => {
            this.toolService.closeLastTool();
        });
    }
}
